import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#fef5f5] py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-3 mb-6 cursor-pointer min-h-[44px]">
              <img 
                src="https://static.readdy.ai/image/ff0b7e80ce034da2f0ffbed7fce4b50d/d817fcc14e7e8fe425753ab5de5ab717.jpeg" 
                alt="Vazcular Logo" 
                className="h-10 w-auto"
              />
              <span className="text-xl font-semibold text-gray-900">Vazcular</span>
            </Link>
            <p className="text-gray-600 mb-6 leading-relaxed text-sm max-w-sm">
              Advanced cardiovascular monitoring technology for better patient outcomes and improved quality of life.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-11 h-11 bg-white rounded-full flex items-center justify-center hover:bg-[#f04e58] hover:text-white transition-all cursor-pointer shadow-sm">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-11 h-11 bg-white rounded-full flex items-center justify-center hover:bg-[#f04e58] hover:text-white transition-all cursor-pointer shadow-sm">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-11 h-11 bg-white rounded-full flex items-center justify-center hover:bg-[#f04e58] hover:text-white transition-all cursor-pointer shadow-sm">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4 md:mb-6 text-base">Company</h4>
            <ul className="space-y-3 md:space-y-4">
              <li>
                <Link to="/our-story" className="text-gray-600 hover:text-[#f04e58] transition-colors cursor-pointer text-sm inline-block min-h-[44px] flex items-center">
                  Our Story
                </Link>
              </li>
              <li>
                <Link to="/our-approach" className="text-gray-600 hover:text-[#f04e58] transition-colors cursor-pointer text-sm inline-block min-h-[44px] flex items-center">
                  Our Approach
                </Link>
              </li>
              <li>
                <Link to="/topics" className="text-gray-600 hover:text-[#f04e58] transition-colors cursor-pointer text-sm inline-block min-h-[44px] flex items-center">
                  Education
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4 md:mb-6 text-base">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/consultation" className="text-gray-600 hover:text-[#f04e58] transition-colors cursor-pointer text-sm inline-block min-h-[44px] flex items-center">
                  Free Consultation
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-[#f04e58] transition-colors cursor-pointer text-sm inline-block min-h-[44px] flex items-center">
                  Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 md:pt-8 border-t border-gray-300">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm text-center md:text-left">
              © 2024 Vazcular. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;